module.exports = __webpack_public_path__ + "static/media/waiting-order-icon.b7eac473.svg";